import descriptors from '../internals/descriptors.js';
import '../internals/object-define-property.js';
import regexpFlags from '../internals/regexp-flags.js';
import fails$1 from '../internals/fails.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var DESCRIPTORS = descriptors;
var objectDefinePropertyModule = objectDefineProperty;
var regExpFlags = regexpFlags;
var fails = fails$1;
var RegExpPrototype = RegExp.prototype;
var FORCED = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  return Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call({
    dotAll: true,
    sticky: true
  }) !== 'sy';
}); // `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags

if (FORCED) objectDefinePropertyModule.f(RegExpPrototype, 'flags', {
  configurable: true,
  get: regExpFlags
});
